export enum YellowAIControlAction {
  Open = 'open',
  Close = 'close',
}

const getYellowAIActionOptions = () => [
  {
    const: YellowAIControlAction.Open,
    title: 'Open chatbot',
    icon: 'SvgMessageChatSquare',
    groupId: 8,
  },
  {
    const: YellowAIControlAction.Close,
    title: 'Close chatbot',
    icon: 'SvgXClose',
    groupId: 8,
  },
];

export const getControlYellowAISchema = () => {
  const actionOptions = getYellowAIActionOptions();

  return {
    type: 'object',
    properties: {
      operation: {
        type: 'string',
        title: 'Operation',
        default: YellowAIControlAction.Open,
        oneOf: actionOptions,
      },
    },
    allOf: [
      {
        if: {
          properties: {
            operation: { const: YellowAIControlAction.Open },
          },
        },
        then: {
          type: 'object',
          properties: {
            userToken: {
              type: 'string',
              title: 'User token',
            },
          },
        },
      },
    ],
  };
};

export const getControlYellowAIUISchema = () => {
  const actionOptions = getYellowAIActionOptions();

  return {
    operation: {
      'ui:title': 'Operation',
      'ui:widget': 'GroupedSelectWidget',
      'ui:options': {
        'ua:enumIcons': actionOptions.map((option) => option.icon),
        'ua:enumGroup': actionOptions.map((option) => option.groupId),
      },
    },
    userToken: {
      'ui:title': 'User token',
      'ui:placeholder': 'Identifies the user to Yellow.ai for their own chat session',
    },
  };
};
